export default "__VITE_ASSET__Dpjs3lrq__"